import { createFileRoute } from "@tanstack/react-router";

import { DashboardsScreen } from "#app/components/dashboards/dashboards-screen";
import { withMemberModule } from "#app/components/permissions/require-permission";

function AllDashboardsRoute() {
  return <DashboardsScreen scope="all" />;
}

export const Route = createFileRoute("/(app)/$workspace/dashboards/")({
  // A member module: a Guest never reaches it (`ModuleTier`). The rail
  // omits the tile; the route denies for itself since the URL still resolves.
  component: withMemberModule(AllDashboardsRoute),
});
